module.exports = __webpack_public_path__ + "static/person-7-70x70-f54c4f503b1a4d9266b3e08038506863.png";